import React from "react";
import ClaimsHistorySvg from "../../../components/svgComponents/ClaimsHistorySvg";
import ReferralHistorySvg from "../../../components/svgComponents/ReferralHistorySvg";
import SearchSvg from "../../../components/svgComponents/SearchSvg";
import TransactionTabSvg from "../../../components/svgComponents/TransactionTabSvg";
import { FILTER_TABS_NAME } from "../constants";
import TableTab from "./TableTab";

const FilterSection = ({ isActiveTab, chooseActiveTab }) => {
  const { claim, referral, transaction } = FILTER_TABS_NAME;
  return (
    <div className="col-span-3 hidden md:grid grid-cols-3 py-4 lg:flex lg:w-fit">
      <TableTab
        handleClick={chooseActiveTab}
        isActiveTab={isActiveTab}
        currentTab={transaction}
        tabName={"Transaction History"}
        tabIcon={
          <TransactionTabSvg isActive={transaction.value === isActiveTab} />
        }
      />
      <TableTab
        handleClick={chooseActiveTab}
        isActiveTab={isActiveTab}
        currentTab={referral}
        tabName={"Referral History"}
        tabIcon={
          <ReferralHistorySvg isActive={referral.value === isActiveTab} />
        }
      />
      <TableTab
        handleClick={chooseActiveTab}
        isActiveTab={isActiveTab}
        currentTab={claim}
        tabName={"XBR Claims History"}
        tabIcon={<ClaimsHistorySvg isActive={claim.value === isActiveTab} />}
      />
    </div>
  );
};

export default FilterSection;
